import { Avatar, Dropdown, Space } from "antd";
import { Chat } from "enums/ChatType";
import "./MustardMessage.scss";
import { useSelector } from "react-redux";
import { DomainState } from "redux-context/domain";
import { getRelativeTimeString } from "helpers/messenger";
import { EllipsisOutlined } from "@ant-design/icons";
import { renderContent } from "./renderMessage";

export const MustardMessage = ({
  content,
  state,
  sender,
  createdAt,
  alignment = "left",
  canDelete = false,
  onDeleteClick = () => {},
}: Chat["messages"][number] & {
  alignment?: "left" | "right";
  canDelete?: boolean;
  onDeleteClick?: () => void;
}) => {
  const { metadata } = useSelector((state: DomainState) => state.domain);
  const isRight = alignment === "right";

  return (
    <div>
      <div className={`mustard-message ${isRight ? "right" : "left"}`}>
        <div className="mustard-message__avatar">
          <Avatar src={metadata?.smallLogoUrl || metadata?.logoUrl} size={30} />
        </div>
        <div className="mustard-message__content">
          {canDelete && (
            <div className="elipsis-outlined">
              <Dropdown
                menu={{
                  items: [
                    {
                      label: "Delete message",
                      key: "0",
                      onClick: onDeleteClick,
                    },
                  ],
                }}
                trigger={["click"]}
              >
                <Space>
                  <div className="mustard-message__dropdown-trigger">
                    <EllipsisOutlined />
                  </div>
                </Space>
              </Dropdown>
            </div>
          )}
          <div>{renderContent(content)}</div>
          <div
            className="mustard-message__sender"
            style={{ textAlign: isRight ? "right" : "left" }}
          >
            {metadata.whiteLabel ? "Support" : sender.name}
            <div
              style={{
                fontSize: 10,
                color: "#999999",
                textAlign: isRight ? "right" : "left",
              }}
            >
              {getRelativeTimeString(new Date(createdAt))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
